// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.

import {
  // wsCreateScriptLine,
  wsUpdateScriptLine,
  // wsDeleteScriptLine,
  // wsCreateScriptSubject,
  wsUpdateScriptSubject,
  // wsDeleteScriptSubject,
  // wsCreateScriptLocation,
  wsUpdateScriptLocation,
  // wsDeleteScriptLocation,
} from "../scripts/scriptsSlices";

import {
  // createBlockScriptLine,
  updateBlockScriptLineSubject,
  updateBlockScriptLineLocation,
  // deleteBlockScriptLine,
} from "../shows/showsSlice";
import { fetchBlockScripts } from "../shows/showsActions";

import {
  wsCreateEquipmentGroup,
  wsUpdateEquipmentGroup,
  wsDeleteEquipmentGroup,
  wsCreatePreset,
  wsUpdatePreset,
  wsDeletePreset,
  wsCreatePresetSequence,
  wsUpdatePresetSequence,
  wsDeletePresetSequence,
  wsCreatePresetSequenceStep,
  wsUpdatePresetSequenceStep,
  wsDeletePresetSequenceStep,
} from "../equipment/equipmentSlice";

/**
 * =====================================================
 * WebSocket Model Data Router
 * =====================================================
 *
 * Centralized routing layer for model-level WebSocket events.
 *
 * This router handles messages of type:
 *   event: "ModelDataChanged"

 * -----------------------------------------------------
 * Expected WebSocket Payload Format
 * -----------------------------------------------------
 * {
 *   type: "event",
 *   mosysId: string | null,
 *   body: {
 *     event: "ModelDataChanged",
 *     data: {
 *       model_name: string,
 *       action: "created" | "updated" | "deleted",
 *       model_data: Record<string, any>
 *     }
 *   }
 * }
 * -----------------------------------------------------
 * TODO : Implement handlers for additional models as backend support is added.
 * -----------------------------------------------------
 * Studio,
 * StudioScene,
 * ScenePurchase,
 * Scene,
 * SceneUnrealVersion,
 * UnrealVersion,
 * Keyword,
 * SceneKeyword,
 * CompanyMember,
 * StudioMember,
 * User,
 * Company,
 * SceneProvider,
 * AccessToken,
 * CompanyMemberInvitation,
 * EquipmentType,
 * EquipmentProperty,
 * Pose,
 * SavedPose,
 * CompanyEquipment,
 * EquipmentPropertyValue,
 * StudioEquipment,
 * PoseType,
 * Show,
 * ShowAccess,
 * EquipmentPropertyValueChoice,
 * ShowPose,
 * ShowEquipment,
 * ShowEquipmentPropertyValue,
 * ShowBlock,
 * ShowStudioDeployment,
 * StudioDeploymentEquipmentMapping,
 * ShowAuthors,
 * ShowScene,
 * BlockEquipment,
 * BlockEquipmentSetting,
 * BlockEquipmentSettingValue,
 * BlockEquipmentSettingChoice,
 * FavouriteScene
 * Preset
 * EquipmentGroup
 * PresetSequence
 * PresetSequenceStep
 */

export const wsModelRouter = {
  ScriptLine: {
    created: (dispatch, modelData) => {
      // TODO: uncomment once backend implements websocket event for create script line
      // dispatch(wsCreateScriptLine(modelData));
      // dispatch(createBlockScriptLine({ newLine: modelData }));
    },
    updated: (dispatch, modelData) => {
      dispatch(wsUpdateScriptLine(modelData));
      dispatch(
        fetchBlockScripts({
          showId: modelData.show_uuid,
          blockId: modelData.show_block_uuid,
        }),
      );
    },
    deleted: (dispatch, modelData) => {
      // TODO: uncomment once backend implements websocket event for delete script line
      // dispatch(wsDeleteScriptLine(modelData));
      // dispatch(deleteBlockScriptLine({ lineId: modelData }));
    },
  },
  ScriptSubject: {
    created: (dispatch, modelData) => {
      // TODO: uncomment once backend implements websocket event for create script subject
      // dispatch(wsCreateScriptSubject(modelData)),
    },
    updated: (dispatch, modelData) => {
      dispatch(wsUpdateScriptSubject(modelData));
      dispatch(updateBlockScriptLineSubject(modelData));
    },
    deleted: (dispatch, modelData) => {
      // TODO: uncomment once backend implements websocket event for delete script subject
      // dispatch(wsDeleteScriptSubject(modelData));
    },
  },
  ScriptLocation: {
    created: (dispatch, modelData) => {
      // TODO: uncomment once backend implements websocket event for create script location
      // dispatch(wsCreateScriptLocation(modelData));
    },
    updated: (dispatch, modelData) => {
      dispatch(wsUpdateScriptLocation(modelData));
      dispatch(updateBlockScriptLineLocation(modelData));
    },
    deleted: (dispatch, modelData) => {
      // TODO: uncomment once backend implements websocket event for delete script location
      // dispatch(wsDeleteScriptLocation(modelData));
    },
  },
  EquipmentGroup: {
    created: (dispatch, modelData) => {
      dispatch(wsCreateEquipmentGroup(modelData));
    },
    updated: (dispatch, modelData) => {
      dispatch(wsUpdateEquipmentGroup(modelData));
    },
    deleted: (dispatch, modelData) => {
      dispatch(wsDeleteEquipmentGroup(modelData));
    },
  },
  Preset: {
    created: (dispatch, modelData) => {
      dispatch(wsCreatePreset(modelData));
    },
    updated: (dispatch, modelData) => {
      dispatch(wsUpdatePreset(modelData));
    },
    deleted: (dispatch, modelData) => {
      dispatch(wsDeletePreset(modelData));
    },
  },
  PresetSequence: {
    created: (dispatch, modelData) => {
      dispatch(wsCreatePresetSequence(modelData));
    },
    updated: (dispatch, modelData) => {
      dispatch(wsUpdatePresetSequence(modelData));
    },
    deleted: (dispatch, modelData) => {
      dispatch(wsDeletePresetSequence(modelData));
    },
  },
  PresetSequenceStep: {
    created: (dispatch, modelData) => {
      dispatch(wsCreatePresetSequenceStep(modelData));
    },
    updated: (dispatch, modelData) => {
      dispatch(wsUpdatePresetSequenceStep(modelData));
    },
    deleted: (dispatch, modelData) => {
      dispatch(wsDeletePresetSequenceStep(modelData));
    },
  },
};
